// NodeConfigPanel.jsx
import GeminiGenerateConfig from "./GeminiGenerateConfig";

export default function NodeConfigPanel({
  activeNodeId,
  logic,
  onContinueToReview,
  onSend,
}) {
  const panelStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "20px",
    background: "rgba(13, 27, 42, 0.7)",
    borderRadius: "12px",
    border: "1px solid rgba(0, 212, 255, 0.2)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
    backdropFilter: "blur(10px)",
    height: "100%",
    overflow: "auto",
  };

  const headerStyle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: 700,
    color: "#ffffff",
    fontFamily: "'Raleway','Poppins', sans-serif",
  };

  const subtextStyle = {
    fontSize: "13px",
    color: "rgba(255, 255, 255, 0.7)",
    marginTop: "6px",
    fontFamily: "'Raleway','Poppins', sans-serif",
    lineHeight: 1.4,
  };

  const inputStyle = {
    padding: "12px 16px",
    borderRadius: "10px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    fontSize: "14px",
    outline: "none",
    background: "rgba(0, 0, 0, 0.3)",
    color: "#ffffff",
    fontFamily: "'Raleway','Poppins', sans-serif",
    transition: "all 0.3s ease",
  };

  switch (activeNodeId) {
    case "generate":
      return (
        <GeminiGenerateConfig
          logic={logic}
          onContinue={onContinueToReview}
        />
      );

    case "review":
      return (
        <div style={panelStyle}>
          {/* HEADER */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
              <span style={{ 
                fontSize: "20px",
                background: "linear-gradient(135deg, #00d4ff, #00ff88)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}>
                📝
              </span>
              <h3 style={headerStyle}>
                Review Email
              </h3>
            </div>
            <p style={subtextStyle}>
              Edit the email content before sending.
            </p>
          </div>

          {/* META */}
          <div
            style={{
              background: "rgba(0, 212, 255, 0.1)",
              padding: "16px",
              borderRadius: "10px",
              fontSize: "14px",
              color: "rgba(255, 255, 255, 0.9)",
              border: "1px solid rgba(0, 212, 255, 0.2)",
              fontFamily: "'Raleway','Poppins', sans-serif",
            }}
          >
            <div style={{ marginBottom: "8px" }}>
              <span style={{ color: "#00d4ff", fontWeight: 600 }}>To:</span>{" "}
              <b style={{ color: "#ffffff" }}>{logic.toEmail || "—"}</b>
            </div>
            <div>
              <span style={{ color: "#00d4ff", fontWeight: 600 }}>Subject:</span>{" "}
              <b style={{ color: "#ffffff" }}>{logic.subject || "—"}</b>
            </div>
          </div>

          {/* EDITOR */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{ 
              fontSize: "14px", 
              fontWeight: 600,
              color: "#00d4ff",
              fontFamily: "'Raleway','Poppins', sans-serif",
            }}>
              Email Body
            </label>
            <textarea
              value={logic.emailBody}
              onChange={(e) => logic.setEmailBody(e.target.value)}
              placeholder="Edit the email body here…"
              style={{
                minHeight: "260px",
                padding: "16px",
                borderRadius: "10px",
                border: "1px solid rgba(0, 212, 255, 0.3)",
                fontSize: "14px",
                lineHeight: 1.5,
                resize: "vertical",
                fontFamily: "'Raleway','Poppins', sans-serif",
                background: "rgba(0, 0, 0, 0.3)",
                color: "#ffffff",
                transition: "all 0.3s ease",
                outline: "none",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#00d4ff";
                e.target.style.boxShadow = "0 0 15px rgba(0, 212, 255, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(0, 212, 255, 0.3)";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          {/* ACTION */}
          <button
            onClick={onSend}
            disabled={!logic.emailBody || !logic.toEmail}
            style={{
              padding: "14px 16px",
              borderRadius: "12px",
              border: "none",
              background: !logic.emailBody || !logic.toEmail
                ? "rgba(0, 212, 255, 0.3)"
                : "linear-gradient(90deg, #00d4ff, #0094ff)",
              color: !logic.emailBody || !logic.toEmail
                ? "rgba(255, 255, 255, 0.5)"
                : "#000",
              fontSize: "14px",
              fontWeight: 600,
              cursor: !logic.emailBody || !logic.toEmail ? "not-allowed" : "pointer",
              opacity: !logic.emailBody || !logic.toEmail ? 0.6 : 1,
              fontFamily: "'Raleway','Poppins', sans-serif",
              transition: "all 0.3s ease",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              if (!(!logic.emailBody || !logic.toEmail)) {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 0 25px rgba(0, 212, 255, 0.6)";
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "none";
            }}
          >
            <span style={{ fontSize: "16px" }}>🚀</span>
            Send this to {logic.toEmail || "recipient"}
          </button>
        </div>
      );

    case "send":
      return (
        <div style={panelStyle}>
          <div style={{ textAlign: "center", padding: "40px 20px" }}>
            <div style={{
              fontSize: "60px",
              marginBottom: "20px",
              animation: "iconFloat 3s ease-in-out infinite"
            }}>
              ✅
            </div>
            <h3 style={{
              ...headerStyle,
              fontSize: "24px",
              background: "linear-gradient(90deg, #00ff88, #00d4ff)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}>
              Success!
            </h3>
            <p style={{
              ...subtextStyle,
              fontSize: "16px",
              color: "rgba(255, 255, 255, 0.9)",
              marginTop: "12px"
            }}>
              Your email has been sent successfully.
            </p>
            <div style={{
              background: "rgba(0, 255, 136, 0.1)",
              padding: "16px",
              borderRadius: "10px",
              marginTop: "20px",
              border: "1px solid rgba(0, 255, 136, 0.3)",
              fontFamily: "'Raleway','Poppins', sans-serif",
              fontSize: "14px",
              color: "rgba(255, 255, 255, 0.9)"
            }}>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#00ff88" }}>To:</span> {logic.toEmail}
              </div>
              <div>
                <span style={{ color: "#00ff88" }}>Subject:</span> {logic.subject}
              </div>
            </div>
          </div>
        </div>
      );

    default:
      return (
        <div style={{
          ...panelStyle,
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "40px 20px"
        }}>
          <div style={{
            fontSize: "48px",
            marginBottom: "20px",
            opacity: 0.5
          }}>
            🤖
          </div>
          <h3 style={{
            ...headerStyle,
            fontSize: "20px",
            color: "rgba(255, 255, 255, 0.7)"
          }}>
            Select a node to configure
          </h3>
          <p style={{
            ...subtextStyle,
            fontSize: "14px"
          }}>
            Click on any node in the flow to see its configuration options
          </p>
        </div>
      );
  }
}

// Add animation styles
const styleTag = document.createElement('style');
styleTag.innerHTML = `
  @keyframes iconFloat {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
  }
  
  input:focus {
    border-color: #00d4ff !important;
    box-shadow: 0 0 15px rgba(0, 212, 255, 0.3) !important;
  }
  
  button:not(:disabled):hover {
    transform: translateY(-2px);
  }
`;

if (typeof document !== 'undefined') {
  document.head.appendChild(styleTag);
}